module.exports = __webpack_public_path__ + "static/img/10.7dc17ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/10.png
// module id = N3PI
// module chunks = 6